import React from 'react';
import { Box, IconButton } from '@mui/material';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import {useTheme} from '@mui/material';

const TopHeader = ({children}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '6px',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: theme.palette.background.default
            }}
        >
            {children}
            <Box sx={{ display: 'flex', flex:1, alignItems: 'center', justifyContent: 'flex-end' }}>
                <IconButton sx={{ color: theme.palette.background.dark }}>
                    <HeadsetMicIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default TopHeader;